import React from "react";
import { FeedbackThumbs } from "../../web/FeedbackThumbs";
import { textSplitByNewLine } from "../utils/textSplitByNewLine";
import { GQLAssistantMessageViewEventsResponse } from "../utils/types";

export const ViewEventsResponse = ({
  message,
}: {
  message: GQLAssistantMessageViewEventsResponse;
}) => {
  return (
    <div className="cw-flex-col cw-items-start cw-body-sm">
      {textSplitByNewLine(message.text)}
      <div className="cw-mt-3">
        <FeedbackThumbs
          msgId={message.id}
          conversationId={message.conversationId}
          orientation="horizontal"
        />
      </div>
    </div>
  );
};
